import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import SurveySubmissionSuccessIcon from '../../illustrations/SurveySubmissionSuccessIcon';
import {
  StyledContainer,
  VisualStackContainer,
  StyledH2Text,
} from './SurveySubmitted.styles';

const SurveySubmitted = () => {
  const { t } = useTranslation(['survey']);

  return (
    <StyledContainer>
      <VisualStackContainer>
        <SurveySubmissionSuccessIcon />
      </VisualStackContainer>
      <StyledH2Text>
        {upperFirst(t('survey:surveySubmittedHeader1'))}
      </StyledH2Text>
    </StyledContainer>
  );
};

export default SurveySubmitted;
